/* yp-cd: cart drawer concepts. One-tap add-on + Master switch, re-rendering the drawer through the theme's own renderContents. */
(function(){
  if (window.__ypCd) return; window.__ypCd = true;
  function sections(){ return ['cart-drawer','cart-icon-bubble']; }
  function paint(state){
    var d=document.querySelector('cart-drawer');
    if (d && typeof d.renderContents==='function' && state && state.sections){ d.renderContents(state); }
    else { location.reload(); }
    try{ if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate,{source:'yp-cd',cartData:state}); }catch(e){}
  }
  function busy(btn,on){ if(!btn) return; btn.setAttribute('aria-busy',on?'true':'false'); }
  document.addEventListener('click',function(e){
    var add=e.target.closest('[data-yp-cd-add]');
    if (add){
      e.preventDefault(); busy(add,true);
      var fd=new FormData(); fd.append('id',add.getAttribute('data-yp-cd-add')); fd.append('quantity','1');
      fd.append('sections',sections().join(',')); fd.append('sections_url',location.pathname);
      fetch((window.routes&&routes.cart_add_url||'/cart/add')+'.js',{method:'POST',body:fd,headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}})
        .then(function(r){return r.json();}).then(function(s){ if(s.status){busy(add,false);return;} paint(s); })
        .catch(function(){busy(add,false);});
      return;
    }
    var sw=e.target.closest('[data-yp-cd-swap]');
    if (sw){
      e.preventDefault(); busy(sw,true);
      var u={}; (sw.getAttribute('data-remove')||'').split(',').forEach(function(id){ if(id) u[id]=0; });
      u[sw.getAttribute('data-add')]=1;
      fetch((window.routes&&routes.cart_update_url||'/cart/update')+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:u,sections:sections(),sections_url:location.pathname})})
        .then(function(r){return r.json();}).then(paint).catch(function(){busy(sw,false);});
    }
  });
})();
